import Box from "@mui/material/Box";

import { useAppSelector } from "~/app/store";

import { selectAndonCompactViewsIds } from "~/features/andon/andon.slice";

import { WorkstationCardCompactView } from "./WorkstationCardCompactView";

export function AndonCompactFullscreen() {
  const compactViewIds = useAppSelector(selectAndonCompactViewsIds);
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "100vh"
      }}
    >
      {/* each workstation is a column */}
      {compactViewIds.map((id) => {
        return <WorkstationCardCompactView key={id} id={id} />;
      })}
    </Box>
  );
}

export default AndonCompactFullscreen;
